import "./Home.module.css";
import Navigation from "@/reusable_sections/Header";
import TheGrainOfTime from "./sections/TheGrainOfTime";
import TheAnalogManifesto from "./sections/TheAnalogManifesto";
import CuratedNarratives from "./sections/CuratedNarratives";
import TheAnalogToolkit from "./sections/TheAnalogToolkit";
import CollectorPerspectives from "./sections/CollectorPerspectives";
import BeginACollaboration from "./sections/BeginACollaboration";
import FooterArchive from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Navigation />
      <TheGrainOfTime />
      <TheAnalogManifesto />
      <CuratedNarratives />
      <TheAnalogToolkit />
      <CollectorPerspectives />
      <BeginACollaboration />
      <FooterArchive />
    </div>;
}